import equal from 'fast-deep-equal';
import {
    Column,
    Container,
    colorWithOpacity,
    cssVar,
    Grid,
    Header,
    Row,
    Separator,
    useAlignments,
    useSizes,
} from 'metrix-common3';
import React, { memo, useState } from 'react';
import styled from 'styled-components';

import BoardCard from '../Card';

const BoardColumnComponent = styled(Container)`
	min-height: 50px;

`;

const CardWrapper = styled(Container)`
	flex-wrap: wrap;
`;

const BoardColumn = memo(
    (props) => {
        const alignments = useAlignments();
        const sizes = useSizes();

        const [hovering, _setHovering] = useState(null);

        return (
            <BoardColumnComponent fullSize left={sizes.xxs} right={sizes.xxs}>
                {props.showHeader && (
                    <React.Fragment>
                        <Header
                            size={sizes.xxs}
                            textAlign={alignments.left}
                            text={`${props.name} (${props.policies.length || 0})`}
                        />
                        <Separator solid bottom={sizes.xxs} />
                    </React.Fragment>
                )}
                <Container
                    fullSize
                    color={
                        hovering === true
                            ? cssVar.colorStrokeLight
                            : colorWithOpacity(cssVar.colorStrokeVeryLight, cssVar.opacityDark)
                    }
                >
                    <Grid>
                        <Row>
                            <Column nogutter>
                                <CardWrapper inline>
                                    {props.policies?.map((policy) => {
                                        return (
                                            <Container bottom={sizes.xs} key={Math.random().toString()}>
                                                <BoardCard
                                                    policy={policy}
                                                    key={policy.policyTransactionGuid}
                                                    reference={props.reference}
                                                    history={props.history}
                                                    assignmentEvent={props.assignmentEvent}
                                                    context={props.context}
                                                    products={props.products}
                                                />
                                            </Container>
                                        );
                                    })}
                                </CardWrapper>
                            </Column>
                        </Row>
                    </Grid>
                </Container>
            </BoardColumnComponent>
        );
    },
    (prevProps, nextProps) => equal(prevProps, nextProps),
);

export default BoardColumn;
